import React, { memo } from 'react';
import { Modal } from 'antd';
import { useDeleteForm } from '../../hooks/use-delete-form';
import { getDeleteModalTitle } from '../../admin-knowledge-base.utils';
import { DeleteForm } from '../forms/delete-form';

type DeleteModalProps = ReturnType<typeof useDeleteForm>;

const DeleteModal = memo(({ form, hide, isOpen, onSubmit, type }: DeleteModalProps) => (
    <Modal
        open={isOpen}
        title={getDeleteModalTitle(type)}
        footer={null}
        onCancel={hide}
    >
        <DeleteForm
            form={form}
            onSubmit={onSubmit}
            close={hide}
        />
    </Modal>
));

export default DeleteModal;
